import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=f478b1d8&scoped=true&"
import script from "./DataExport.vue?vue&type=script&lang=js&"
export * from "./DataExport.vue?vue&type=script&lang=js&"
import style0 from "./DataExport.vue?vue&type=style&index=0&id=f478b1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478b1d8",
  null
  
)

export default component.exports